module.exports = __webpack_public_path__ + "static/media/coach.2cd030ed.png";